<p-dialog [visible]="visivel" (visibleChange)="$event ? null : fechar()" (onShow)="aoAbrir()" [modal]="true" [draggable]="false"
  [resizable]="false" [dismissableMask]="true" [style]="{ width: '60rem' }" [breakpoints]="{ '991px': '95vw' }"
  styleClass="adicionar-widget" header="Adicionar widget">

  <p class="subtitulo">
    @if (slot) {
      Posição escolhida: linha {{ slot.linha + 1 }}, coluna {{ slot.coluna + 1 }} (canto superior esquerdo do widget).
    } @else {
      O widget será colocado na primeira posição livre.
    }
  </p>

  @if (carregandoModulos) {
    <div class="flex justify-content-center p-4"><p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4" /></div>
  } @else if (!modulos.length) {
    <div class="vazio">
      <i class="pi pi-inbox"></i>
      <span>Nenhum widget disponível para você.</span>
    </div>
  } @else {
    <div class="corpo">
      <nav class="modulos" aria-label="Módulos">
        @for (modulo of modulos; track modulo.id) {
          <button type="button" class="modulo" [class.ativo]="modulo === moduloSelecionado" (click)="selecionarModulo(modulo)">
            {{ modulo.descricao || modulo.nome }}
          </button>
        }
      </nav>

      <div class="cards-area">
        @if (mensagemNaoCabe) {
          <p-message severity="error" [text]="mensagemNaoCabe" styleClass="w-full justify-content-start mb-3" />
        }

        @if (carregandoWidgets) {
          <div class="flex justify-content-center p-4"><p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="4" /></div>
        } @else {
          <div class="cards">
            @for (widget of widgets; track widget.id) {
              <button type="button" class="card-widget" [class.nao-cabe]="naoCabe(widget)" (click)="selecionarWidget(widget)"
                [attr.data-widget]="widget.identificador">
                <span class="topo">
                  <i [ngClass]="widget.icone || 'pi pi-th-large'"></i>
                  <strong>{{ widget.nome }}</strong>
                </span>
                <span class="descricao">{{ widget.descricao }}</span>
                <span class="rodape">
                  <span class="miniatura" [attr.aria-label]="widget.largura + ' × ' + widget.altura">
                    @for (celula of miniatura; track $index) {
                      <i [class.on]="ocupadaNaMiniatura(widget, celula)"></i>
                    }
                  </span>
                  <span class="tags">
                    @if (widget.ativo === false) {
                      <p-tag value="Inativo" severity="warning" />
                    }
                    @if (naoCabe(widget)) {
                      <p-tag value="Não cabe aqui" severity="danger" />
                    } @else {
                      <p-tag [value]="widget.largura + ' × ' + widget.altura" severity="secondary" />
                    }
                  </span>
                </span>
              </button>
            } @empty {
              <span class="text-color-secondary">Nenhum widget neste módulo.</span>
            }
          </div>
        }
      </div>
    </div>
  }
</p-dialog>
